import { bootstrapApplication } from '@angular/platform-browser';
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { isAuthResponseFrame } from './config/auth-response-frame';
import { initializeMsalInstance } from './config/MSALConfig';

window.MonacoEnvironment = {
  getWorkerUrl: function () {
    return 'data:text/javascript;charset=utf-8,';
  },
};

if (isAuthResponseFrame(window)) {
  broadcastResponseToMainFrame().catch(err => console.error('[MSAL] Silent renewal response not relayed:', err));
} else {
  initializeMsalInstance()
    .then(() => bootstrapApplication(AppComponent, appConfig))
    .then(ref => {
      if (window.ngRef) {
        window.ngRef.destroy();
      }
      window.ngRef = ref;
    })
    .catch(err => console.error(err));
}
